module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "green_head"
  }, [_c('p', {
    staticClass: "fm-head1",
    attrs: {
      "id": "fm03-001"
    }
  }, [_c('b', [_c('span', {
    staticClass: "green_head"
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Spoiler alert: I’m a total puzzle nerd. Not just the jigsaw kind, either—I’m talking about those mind-bending, mental-acrobatics–type exercises that leave you scratching your head but unable to think about anything else. Suffice it to say, when I first stumbled upon foundation paper piecing, the attraction was immediate. Mysterious markings on papers that magically fit together and transform fabric into super-graphic designs? Pretty much my dream come true. And the best part? "), _c('i', [_vm._v("All puzzles have solutions.")]), _vm._v(" You just have to understand the mechanics so you know how to stay on track (and what to do if and when you veer off course).")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("It just so happens I’ve spent years making mistakes with this method. That’s where this book comes in: "), _c('i', [_vm._v("Adventures in Paper Piecing & Design")]), _vm._v(" is the culmination of all my trial, error, and takeaways since paper piecing my first block all those years ago. It provides the tools to thrive when confronted with just about any paper-piecing challenge, from straightforward sequences to the Mount Everest of designs. Along the way, you’ll build (or reinforce) a solid skill set, learn how to break down patterns, and ultimately create designs of your own.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "bd1"
  }, [_vm._v("You’ll accomplish this in three parts:")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "bd1"
  }, [_vm._v("I.")]), _vm._v(" A detailed overview of the foundation-paper-piecing (FPP) method (the building blocks, if you will)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "bd1"
  }, [_vm._v("II.")]), _vm._v(" An introduction to FPP design (that is, designing your own patterns)")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "bd1"
  }, [_vm._v("III.")]), _vm._v(" Design exercise prompts, paired with my own narrated example, to help you master the process and get your creative juices flowing")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("One note about the inspiration for this book: As the saying goes, it’s literally everywhere. For both the prompts and my takes on them, I chose accessible subject matter (think traditional blocks, typography, and everyday items like houseplants and bugs) so that you could use this as a workbook of sorts and draw upon your own muses for any given exercise. To be sure, I’ve poured so much of myself into this book—from the backstories to the collage boards to the narratives behind the blocks. Still, I’ve tried to do it in a way that encourages "), _c('i', [_vm._v("you")]), _vm._v(" to explore "), _c('i', [_vm._v("your")]), _vm._v(" process rather than feeling confined to mine. To that end, consider this book a springboard for your own personal foundation-paper-piecing adventures.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And in that spirit … here we go!")]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353926f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_intro.vue
// module id = 69
// module chunks = 0